// src/marketing/launch/dates.ts

/**
 * Calcule la date calendaire d'une tâche de lancement.
 * @param launchDate  D0 au format ISO date "YYYY-MM-DD" (null si non définie)
 * @param dayOffset   nombre de jours relatifs à D0 (négatif = avant ; null = tâche flottante)
 * @returns Date calendaire au format "YYYY-MM-DD", ou null si launchDate ou dayOffset est null
 */
export function launchTaskDate(
  launchDate: string | null,
  dayOffset: number | null,
): string | null {
  if (launchDate === null || dayOffset === null) return null
  const d = new Date(launchDate)
  d.setUTCDate(d.getUTCDate() + dayOffset)
  return d.toISOString().slice(0, 10)
}
